(
    function (skyward, $)
    {
        skyward.cashreceipt = skyward.cashreceipt || {};

        var init = function (selector)
        {
            $(selector).find(".CashReceiptClickControlARWorkflow").each(function ()
            {
                registerControlWorkflow(this, true, "Account/CashReceipt/UpdateARCashReceiptAmountsWorkflow");
            });

            $(selector).find(".CashReceiptClickControlARUnappliedWorkflow").each(function ()
            {
                registerControlWorkflow(this, true, "Account/CashReceipt/UpdateARApplyUnappliedAmountAmountsWorkflow");
            });

            $(selector).find('.CashReceiptDepositWorkflowActivityAccountingGroupID').change(onActivityAccountingGroupIDChanged)
        };

        var registerControlWorkflow = function (control, isClick, urlEnding)
        {
            var element = $(control);
            if (isClick)
            {
                element.on('click', function (event)
                {
                    sendAjaxWorkflow(event, null, urlEnding);
                });
            }
            else
            {
                element.on('change', function (event)
                {
                    sendAjaxWorkflow(event, null, urlEnding);
                });
            }

            if (control.value)
            {
                sendAjaxWorkflow(null, control.name, urlEnding);
            }
        };

        var sendAjaxWorkflow = function (event, targetName, urlEnding)
        {
            skyward.ajax.getAllInputElements(".workflowContent").then(postData =>
            {
                if (!event)
                {
                    postData._controlAjaxFiredFrom = targetName;
                }
                else
                {
                    postData._controlAjaxFiredFrom = event.currentTarget.id;
                }
                $.ajax({
                    url: skyward.global.virtualDir + urlEnding,
                    type: "POST",
                    dataType: "JSON",
                    data: postData,
                    success: function (data)
                    {
                        handleResponse(data);
                    }
                });
            });
        }

        var handleResponse = function (data)
        {
            if (data == null)
            {
                return;
            }
            var updates = data.Update || {};
            for (field in updates)
            {
                var nameElement = $("[name='" + field + "']");
                if (nameElement.length == 0)
                {
                    nameElement = $("#" + field);
                }

                var nameElementIsActive =
                    nameElement[0] &&
                    document.activeElement &&
                    nameElement[0] == document.activeElement &&
                    nameElement[0].selectionStart == 0 &&
                    nameElement[0].selectionEnd > 0 &&
                    nameElement[0].selectionEnd == nameElement[0].value.length;

                skyward.controls.setValue(nameElement, updates[field], true);

                var elementData = nameElement.data();
                if (nameElement.is("[data-mask]"))
                {
                    skyward.datamask.addMask(nameElement, elementData.mask, null);
                }

                if (nameElementIsActive)
                {
                    nameElement.select();
                }
            }
        };

        function onActivityAccountingGroupIDChanged(event)
        {
            var hide = skyward.controls.getValue(event.target).length != 0;

            var arButton = $("a[id$='customButton_SaveAndAddCashReceiptForAR']");
            var arUnappliedButton = $("a[id$='customButton_SaveAndAddCashReceiptForARUnapplied']");
            var bmButton = $("a[id$='customButton_SaveAndAddCashReceiptForBM']");

            if (hide)
            {
                arButton.hide();
                arButton.removeClass('moreMenuButton'); // This class is responsible for showing/hiding the workflow buttons when a code eel opens
                arUnappliedButton.hide();
                arUnappliedButton.removeClass('moreMenuButton');
                bmButton.hide();
                bmButton.removeClass('moreMenuButton');
            }
            else
            {
                arButton.show();
                arButton.addClass('moreMenuButton');
                arUnappliedButton.show();
                arUnappliedButton.addClass('moreMenuButton');
                bmButton.show();
                bmButton.addClass('moreMenuButton');
            }
        }

        // Bootstrap
        skyward.window.registerLoadDOMCallback(init);
    }(window.skyward = window.skyward || {}, window.jQuery)
);
